import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/api/client";
import { toast } from "sonner";
import { DocStatusBadge } from "@/lib/pipeline";

export function CandidateExpiry() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/pipeline/expiring-docs").then(({ data }) => setItems(data)).catch((err) => { toast.error(formatApiError(err)); setItems([]); }); }, []);
  if (!items) return <div className="py-16 text-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400 inline" /></div>;
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid="candidate-expiry-list">
      <ul>
        {items.map((d) => (
          <li key={d.id} className="flex items-center justify-between gap-3 px-4 sm:px-5 py-3 border-t first:border-t-0 border-slate-100" data-testid={`candidate-expiry-${d.id}`}>
            <div className="min-w-0">
              <Link to={`/candidates/${d.candidate_id}`} className="font-medium text-slate-800 hover:text-cyan-700">{d.candidate_name}</Link>
              <span className="text-xs text-slate-400 ml-2">{d.rank}</span>
              <div className="text-xs text-slate-500 font-mono mt-0.5">{d.document_type} · {d.expiry_date} · {d.days_left < 0 ? `${-d.days_left} days ago` : `${d.days_left} days left`}</div>
            </div>
            <DocStatusBadge status={d.status} />
          </li>
        ))}
      </ul>
      {items.length === 0 && <div className="py-14 text-center text-sm text-slate-500" data-testid="candidate-expiry-empty">No candidate documents expired or expiring within 30 days.</div>}
    </div>
  );
}
